import React, {FC} from "react"
import cls from "../shop.module.scss";
import {TranslationsType} from "../../../types/homePageTypes";
const TableHead:FC<{ translationsData: TranslationsType }> = (
    {
        translationsData: {
            Product: ProductIntl,
            Price: PriceIntl,
            Quantity: QuantityIntl,
            SubTotal: SubTotalIntl
        }
    }
) => {
    const thArrayHandle = [
        { clsColumnName: "image", intlValue: ProductIntl },
        { clsColumnName: "product", intlValue: "" },
        { clsColumnName: "price", intlValue: PriceIntl },
        { clsColumnName: "quantity", intlValue: QuantityIntl },
        { clsColumnName: "product", intlValue: SubTotalIntl }
    ]
    return (
        <thead className={cls["cart-table__head"]}>
            <tr className={cls["cart-table__row"]}>
                {thArrayHandle.map(({clsColumnName, intlValue}) => {
                    return (
                        <th className={`${cls["cart-table__column"]} ${cls[`cart-table__column--${clsColumnName}`]}`}>
                            {intlValue}
                        </th>
                    )
                })}
                <th
                    className={`${cls["cart-table__column"]} ${cls["cart-table__column--remove"]}`}
                    aria-label="Remove"
                />
            </tr>
        </thead>
    )
}

export default TableHead;
